import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import {
  getPostLoginRedirectPath,
  isAuthenticated,
} from "helpers/authSession";

import LoginBrandPanel from "./LoginBrandPanel";
import LoginForm from "./LoginForm";
import { LOGIN_COPY } from "./constants/loginContent";
import styles from "./Login.module.scss";

const Login = () => {
  const location = useLocation();

  if (isAuthenticated()) {
    return (
      <Navigate to={getPostLoginRedirectPath(location.search)} replace />
    );
  }

  return (
    <div className={styles.rootContainer}>
      <LoginBrandPanel />

      <div className={styles.formPanel}>
        <div className={styles.loginCard}>
          <h2 className={styles.loginHeading}>{LOGIN_COPY.SIGN_IN_HEADING}</h2>
          <p className={styles.loginSubheading}>
            {LOGIN_COPY.SIGN_IN_SUBHEADING}
          </p>
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default Login;
